import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import uniqid from "uuid/v4";
import Layout from "layouts/DashboardManage";
import { getWorkflow, updateWorkflow } from "store/actions/workflowAction";
import { getAllUsers } from "store/actions/userAction";
import { getAllTeams } from "store/actions/teamAction";
import hasProperty from "lodash/has";
import uniqueArray from "lodash/uniq";
import { has, isEmpty } from "lodash";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import Desktop from "./Workflow/Desktop";
import Team from "./Workflow";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class Edit extends Component {
  state = {
    name: "",
    userWorkflow: {
      uuid: uniqid(),
      order: 1,
      workflow_type: "users",
      source_users: [],
      destination_team: {}
    },
    teamWorkflows: [],
    ignoredTeams: [],
    showAddMoreWorkflow: false
  };

  componentDidMount() {
    this.props.getWorkflow(this.props.match.params.workflowId);
    this.props.getAllUsers({
      clientId: this.props.match.params.clientId,
      userType: "desktop"
    });
    this.props.getAllTeams({
      clientId: this.props.match.params.clientId
    });
  }

  componentDidUpdate(prevProps) {
    // Update state with the data from the db
    if (
      prevProps.workflow !== this.props.workflow &&
      hasProperty(this, "props.workflow.data.workflows")
    ) {
      let teamWorkflows = [];
      const workflows = this.props.workflow.data.workflows;
      let userWorkflow = workflows.slice(0, 1)[0];

      if (userWorkflow?.source_users) {
        userWorkflow.source_users = userWorkflow.source_users.map(user => ({
          label: user.fullname,
          tooltip: user.email,
          value: user.id
        }));
      }

      if (userWorkflow?.destination_team) {
        userWorkflow.destination_team = {
          label: userWorkflow.destination_team.name,
          tooltip: userWorkflow.destination_team.name,
          value: userWorkflow.destination_team.id
        };
      }

      if (this.props.workflow.data.workflows.length > 1) {
        teamWorkflows = workflows.slice(1);
        teamWorkflows = teamWorkflows.map(wf => ({
          ...wf,
          source_team: {
            label: wf.source_team.name,
            tooltip: wf.source_team.name,
            value: wf.source_team.id
          },
          destination_team: {
            label: wf.destination_team.name,
            tooltip: wf.destination_team.name,
            value: wf.destination_team.id
          },
          order: wf.order - 1
        }));
      }

      const defaultUserWorkflow = {
        uuid: uniqid(),
        order: 1,
        workflow_type: "users",
        source_users: [],
        destination_team: {}
      };
      this.setState(
        {
          name: this.props.workflow.data.name,
          userWorkflow: userWorkflow || defaultUserWorkflow,
          teamWorkflows: teamWorkflows || []
        },
        () => this.updateIgnoredTeams()
      );
    }

    // When the department is updated successfully, we will redirect to manage page
    if (
      prevProps.updateWorkflowResponse !== this.props.updateWorkflowResponse &&
      hasProperty(this, "props.updateWorkflowResponse.id")
    ) {
      // Redirect to manage page
      this.props.history.push(
        `/manage/clients/${this.props.match.params.clientId}/workflows/manage`
      );
    }

    // When there was a problem creating the new workflow
    if (
      prevProps.errorWorkflow !== this.props.errorWorkflow &&
      this.props.errorWorkflow &&
      Object.keys(this.props.errorWorkflow).length > 0
    ) {
      notifyApiError(this.props.errorWorkflow);
    }
  }

  handleChange = e => {
    e.persist();
    this.setState(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  handleUpdate = () => {
    const workflows = [];
    workflows.push({
      ...this.state.userWorkflow,
      order: 1,
      workflow_type: "users",
      source_users: hasProperty(this, "state.userWorkflow.source_users")
        ? this.state.userWorkflow.source_users.map(s => s.value)
        : {},
      destination_team: hasProperty(
        this,
        "state.userWorkflow.destination_team.value"
      )
        ? this.state.userWorkflow.destination_team.value
        : ""
    });

    const teamWorkflows = this.state.teamWorkflows.map(twf => {
      return {
        ...twf,
        order: twf.order + 1,
        workflow_type: "teams",
        source_team: twf.source_team.value,
        destination_team: hasProperty(twf, "destination_team.value")
          ? twf.destination_team.value
          : ""
      };
    });
    workflows.push(...teamWorkflows);

    this.props.updateWorkflow({
      id: this.props.match.params.workflowId,
      data: {
        name: this.state.name,
        client: this.props.match.params.clientId,
        workflows
      }
    });
  };

  updateIgnoredTeams = () => {
    let usedTeams = [];
    if (hasProperty(this, "state.userWorkflow.destination_team.value")) {
      usedTeams.push(this.state.userWorkflow.destination_team.value);
    }

    for (const team of this.state.teamWorkflows) {
      usedTeams.push(team.destination_team.value);
    }

    usedTeams = uniqueArray(usedTeams);
    this.setState(
      {
        ignoredTeams: usedTeams
      },
      () => {
        this.showAddMoreWorkflow();
        this.props.getAllTeams({
          clientId: this.props.match.params.clientId,
          ignoreIds: this.state.ignoredTeams
        });
      }
    );
  };

  showAddMoreWorkflow = () => {
    if (
      !has(this, "state.userWorkflow.source_users") ||
      !has(this, "state.userWorkflow.destination_team") ||
      isEmpty(this.state.userWorkflow.source_users) ||
      isEmpty(this.state.userWorkflow.destination_team)
    ) {
      this.setState({
        showAddMoreWorkflow: false
      });
      return;
    }

    for (const wf of this.state.teamWorkflows) {
      if (isEmpty(wf.source_team) || isEmpty(wf.destination_team)) {
        this.setState({
          showAddMoreWorkflow: false
        });
        return;
      }
    }

    this.setState({
      showAddMoreWorkflow: true
    });
  };

  removeSucceedingWorkflows = workflow => {
    this.setState(
      prevState => ({
        teamWorkflows: prevState.teamWorkflows.filter(
          wf => wf.order <= workflow.order
        )
      }),
      () => {
        this.updateIgnoredTeams();
      }
    );
  };

  onDesktopUserSelect = item => {
    this.setState(
      prevState => {
        return {
          userWorkflow: {
            ...prevState.userWorkflow,
            source_users: hasProperty(prevState, "userWorkflow.source_users")
              ? [...prevState.userWorkflow.source_users, item]
              : []
          }
        };
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
      }
    );
  };

  onDesktopTeamSelect = item => {
    this.setState(
      {
        userWorkflow: {
          ...this.state.userWorkflow,
          destination_team: item
        },
        ignoredTeams: [...this.state.ignoredTeams, item.value]
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
      }
    );
  };

  onDesktopUserRemove = userId => {
    this.setState(
      {
        userWorkflow: {
          ...this.state.userWorkflow,
          source_users: this.state.userWorkflow.source_users.filter(
            u => u.value !== userId
          )
        }
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
      }
    );
  };

  onDesktopTeamRemove = uuidTeam => {
    this.setState(
      {
        ...this.state,
        userWorkflow: {
          ...this.state.userWorkflow,
          destination_team: {}
        },
        ignoredTeams: this.state.ignoredTeams.filter(t => t !== uuidTeam)
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
        this.props.getAllTeams({
          clientId: this.props.match.params.clientId,
          ignoreIds: this.state.ignoredTeams
        });
      }
    );
  };

  onTeamSelect = (selectedTeam, uuidWorkflow) => {
    this.setState(
      prevState => {
        const newTeamWorkflow = prevState.teamWorkflows.find(
          tw => tw.uuid === uuidWorkflow
        );
        newTeamWorkflow.destination_team = selectedTeam;

        return {
          teamWorkflows: prevState.teamWorkflows,
          ignoredTeams: [...prevState.ignoredTeams, selectedTeam.value]
        };
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
      }
    );
  };

  onTeamRemove = uuidTeam => {
    this.setState(
      prevState => {
        return {
          teamWorkflows: prevState.teamWorkflows.map(t => {
            if (t.destination_team.value === uuidTeam) {
              t.destination_team = {};
            }
            return t;
          }),
          ignoredTeams: this.state.ignoredTeams.filter(t => t !== uuidTeam)
        };
      },
      () => {
        this.updateIgnoredTeams();
        this.showAddMoreWorkflow();
        this.props.getAllTeams({
          clientId: this.props.match.params.clientId,
          ignoreIds: this.state.ignoredTeams
        });
      }
    );
  };

  onTeamDeleteWorkflow = workflow => {
    this.setState(
      prevState => ({
        teamWorkflows: prevState.teamWorkflows.filter(
          wf => wf.order < workflow.order
        )
      }),
      () => {
        this.updateIgnoredTeams();
      }
    );
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit-workflow">
          <h1 className="title mb-30">{Translate({ id: "edit_workflow" })} </h1>
          <div className="workflow-name-wrapper mb-30">
            <div className="workflow-name">
              <label className="title">
                {Translate({ id: "workflow_name" })}{" "}
              </label>
              <Textbox
                id="name"
                name="name"
                errors={this.props.errorWorkflow}
                errorKey="name"
                type="text"
                fieldValue={this.state.name}
                autoComplete="off"
                onChange={this.handleChange}
                onReturnKey={this.handleUpdate}
                placeholder={Translate({ id: "my_workflow" })}
              />
            </div>
          </div>

          <hr className="my-20" />

          <div className="workflows">
            {/* <!-- Workflow 1 --> */}
            <Desktop
              clientId={this.props.match.params.clientId}
              userWorkflow={this.state.userWorkflow}
              teamWorkflowsLength={this.state.teamWorkflows.length}
              ignoredTeams={this.state.ignoredTeams}
              onUserSelect={item => this.onDesktopUserSelect(item)}
              onTeamSelect={item => this.onDesktopTeamSelect(item)}
              onUserRemove={userId => this.onDesktopUserRemove(userId)}
              onTeamRemove={uuidTeam => this.onDesktopTeamRemove(uuidTeam)}
              removeSucceedingWorkflows={() =>
                this.removeSucceedingWorkflows({ order: 0 })
              }
              errorWorkflow={this.props.errorWorkflow}
            />

            {/* <!-- Workflow 2 --> */}
            {this.state.teamWorkflows.map((teamWorkflow, idx) => (
              <Team
                key={idx}
                clientId={this.props.match.params.clientId}
                teamWorkflow={teamWorkflow}
                teamWorkflowsLength={this.state.teamWorkflows.length}
                ignoredTeams={this.state.ignoredTeams}
                onTeamSelect={selectedTeam =>
                  this.onTeamSelect(selectedTeam, teamWorkflow.uuid)
                }
                onTeamRemove={uuidTeam => this.onTeamRemove(uuidTeam)}
                removeSucceedingWorkflows={() =>
                  this.removeSucceedingWorkflows(teamWorkflow)
                }
                onDeleteWorkflow={() => this.onTeamDeleteWorkflow(teamWorkflow)}
                errorWorkflow={this.props.errorWorkflow}
              />
            ))}
            {this.state.showAddMoreWorkflow && (
              <button
                className="btn btn-default"
                data-test="btnaddmore"
                onClick={() => {
                  this.setState(
                    prevState => {
                      return {
                        teamWorkflows: [
                          ...prevState.teamWorkflows,
                          {
                            uuid: uniqid(),
                            workflow_type: "teams",
                            order: prevState.teamWorkflows.length + 1,
                            source_team:
                              prevState.teamWorkflows.length === 0
                                ? prevState.userWorkflow.destination_team
                                : prevState.teamWorkflows[
                                    prevState.teamWorkflows.length - 1
                                  ].destination_team,
                            destination_team: {}
                          }
                        ]
                      };
                    },
                    () => {
                      this.updateIgnoredTeams();
                      this.showAddMoreWorkflow();
                    }
                  );
                }}
              >
                <i className="fas fa-plus"></i>{" "}
                {Translate({ id: "add_another_workflow" })}
              </button>
            )}
          </div>

          <div className="save-cancel-buttons">
            <Link
              to={`/manage/clients/${this.props.match.params.clientId}/workflows/manage`}
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="update"
              isLoading={this.props.workflowLoading}
              handleSubmit={this.handleUpdate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Edit.propTypes = {
  updateWorkflow: PropTypes.func.isRequired,
  getAllUsers: PropTypes.func.isRequired,
  getAllTeams: PropTypes.func.isRequired,
  getWorkflow: PropTypes.func.isRequired,
  updateWorkflowResponse: PropTypes.object,
  users: PropTypes.object,
  teams: PropTypes.object,
  errorWorkflow: PropTypes.object,
  isLoading: PropTypes.bool,
  workflowLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    updateWorkflowResponse: state.workflow.updateWorkflow,
    workflow: state.workflow.getWorkflow,
    teams: state.team.getAllTeams,
    users: state.user.getAllUsers,
    errorWorkflow: state.workflow.errorWorkflow,
    isLoading: state.user.isLoadingUser,
    workflowLoading: state.workflow.isLoadingWorkflow
  };
};

export default connect(mapStateToProps, {
  updateWorkflow,
  getWorkflow,
  getAllUsers,
  getAllTeams
})(Edit);
